import cx from 'classnames'
import Link from 'next/link'

import type { SupportedCurrencies } from 'types/currencies'

import Badge from '../Badge'
import classes from '../GameInfo/styles.module.scss'

type Props = {
  isDarkMode: boolean
  activeCurrency: SupportedCurrencies
  isLoggedIn: boolean
  descriptionColor: string
  gameType: string
  categoryLink: string
  typeTitle: string
}

export default function GameType(props: Props) {
  const { activeCurrency, isLoggedIn, isDarkMode, gameType, categoryLink, descriptionColor, typeTitle } = props

  return (
    <Link
      className={cx(classes.gameInfoCol, isDarkMode && classes.darkMode)}
      href={categoryLink}
      prefetch={false}
      data-testid='game-type-link'
    >
      <Badge activeCurrency={activeCurrency} isLoggedIn={isLoggedIn} />
      <span className={cx('mt-typography-caption', classes.caption, isDarkMode && classes.captionDarkMode)}>
        {typeTitle}
      </span>
      <b className={cx(classes.description, classes.categoryLink, classes.customUnderline, descriptionColor)}>
        {gameType.toUpperCase()}
      </b>
    </Link>
  )
}
